export const VALID_CONTENT_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/heic',
  'image/heic-sequence',
  'image/heif',
  'image/heif-sequence',
  'application/pdf',
  'application/x-pdf',
]

export enum EMobileMessage {
  COMPANY_INFO_COLLECTED = 'COMPANY_INFO_COLLECTED',
  DOCUMENT_UPLOAD_COMPLETE = 'DOCUMENT_UPLOAD_COMPLETE',
  SKIPPED_DOCUMENT_UPLOAD = 'SKIPPED_DOCUMENT_UPLOAD',
}

export enum EActivationStep {
  bca = 'bca',
  insurance = 'insurance',
  documents = 'documents',
  safetyLetter = 'safetyLetter',
}

export const NO_DATA_LABEL = 'No data available'
